import { createApp } from 'vue'
import { createPinia } from 'pinia'
import App from './App.vue'
import router from './router'

import 'vant/lib/index.css'
import './style/vantui.scss'  
import './style/index.scss'
import './style/common.scss'

import { handleGlobalBack } from './utils/backHandler.js'
import { API_CONFIG, PAGE_CONFIG } from './config/index.js'
import { setToken, getToken } from './utils/storage'
import { isInWechatWork, silentLogin } from './utils/wecom'

// 引入移动端适配库
import 'lib-flexible'

// 页面加载时立即处理URL中的token和redirect参数
// 使用sessionStorage防止重复跳转
;(async function handleUrlParams() {
  const url = new URL(window.location.href)
  const params = url.searchParams
  const token = params.get('token')
  const redirect = params.get('redirect')
  const pathWithQuery = url.pathname + url.search
  
  console.log('[URL处理] 当前URL:', url.href)
  console.log('[URL处理] token参数:', token ? '有' : '无')
  console.log('[URL处理] redirect参数:', redirect)
  console.log('[URL处理] 是否企微环境:', isInWechatWork())
  
  // 保存token到本地存储
  if (token) {
    setToken(token)
    console.log('[URL处理] 已保存token到本地存储')
  }
  
  // 检查本地是否已有token（用户已登录）
  let existingToken = getToken()
  console.log('[URL处理] 本地token:', existingToken ? '存在' : '不存在')
  
  // 检查是否已经处理过这个URL（防止循环跳转）
  const processedKey = 'wecom_redirect_processed'
  const processedPath = sessionStorage.getItem(processedKey)
  
  if (redirect === 'wecom') {
    // 如果已经处理过这个路径，直接清理参数
    if (processedPath === pathWithQuery) {
      console.log('[URL处理] 已处理过此URL，清理参数')
      params.delete('token')
      params.delete('redirect')
      window.history.replaceState({}, '', url.toString())
      sessionStorage.removeItem(processedKey)
      return
    }
    
    // 如果用户已登录（本地有token），直接清理redirect参数
    if (existingToken) {
      console.log('[URL处理] 用户已登录，清理redirect参数')
      params.delete('token')
      params.delete('redirect')
      window.history.replaceState({}, '', url.toString())
      return
    }
    
    // 企微环境：尝试JS-SDK静默登录
    if (isInWechatWork()) {
      console.log('[URL处理] 企微环境，尝试静默登录...')
      const loginResult = await silentLogin()
      
      if (loginResult && !loginResult.needBind) {
        // 静默登录成功
        console.log('[URL处理] 静默登录成功，清理参数')
        params.delete('token')
        params.delete('redirect')
        window.history.replaceState({}, '', url.toString())
        return
      } else if (loginResult?.needBind) {
        // 需要绑定账号，跳转到绑定页面
        console.log('[URL处理] 需要绑定账号')
        window.location.replace(`/bind-account?openid=${loginResult.data.openid}&platform=${loginResult.data.platform}`)
        return
      }
      
      // 静默登录失败，继续走OAuth流程
      console.log('[URL处理] 静默登录失败，继续OAuth流程')
    }
    
    // 标记正在处理
    sessionStorage.setItem(processedKey, pathWithQuery)
    console.log('[URL处理] 用户未登录，保留redirect参数让路由守卫处理')
    
    // 如果有token参数，说明是从callback跳转来的，清理参数
    if (token) {
      params.delete('token')
      params.delete('redirect')
      window.history.replaceState({}, '', url.toString())
      console.log('[URL处理] 已清理token和redirect参数')
    }
    // 如果没有token，保留redirect让路由守卫处理
  } else if (token) {
    // 只有token，清理token参数
    params.delete('token')
    window.history.replaceState({}, '', url.toString())
    console.log('[URL处理] 已清理token参数')
  }
})()

// 引入Vant组件
import { 
    Button, NavBar, Toast, Dialog, Field, Form, Cell, CellGroup, Tabbar, TabbarItem, 
    Card, Grid, GridItem, Step, Steps, Uploader, Popup, Swipe, SwipeItem,
     Tabs, Tab, Checkbox, Notify, Icon, Sticky, List, Empty, DatePicker, Tag,
     Progress, Loading, Skeleton, Picker, ActionSheet, PullRefresh, Radio, RadioGroup, CountDown, Search,
     Image, Collapse, CollapseItem, SwipeCell
} from 'vant'

// 引入自定义组件
import NavMenu from './components/common/NavMenu.vue'


const app = createApp(App)
const pinia = createPinia()

app.config.globalProperties.PAGE_NUM = PAGE_CONFIG.PAGE_NUM;
app.config.globalProperties.PAGE_SIZE = PAGE_CONFIG.PAGE_SIZE;
app.config.globalProperties.PAGE_ARRAY = PAGE_CONFIG.PAGE_ARRAY;

// 注册Vant组件
app.use(Button)
app.use(NavBar)
app.use(Toast)
app.use(Dialog)
app.use(Field)
app.use(Form)
app.use(Cell)
app.use(CellGroup)
app.use(Tabbar)
app.use(TabbarItem)
app.use(Card)
app.use(Grid)
app.use(GridItem)
app.use(Step)
app.use(Steps)
app.use(Uploader)
app.use(Popup)
app.use(Swipe)
app.use(SwipeItem)
app.use(Tabs)
app.use(Tab)
app.use(Checkbox)
app.use(Notify)
app.use(Icon)
app.use(Sticky)
app.use(List)
app.use(DatePicker)
app.use(Tag)
app.use(Progress)
app.use(Loading)
app.use(Skeleton)
app.use(Picker)
app.use(ActionSheet)
app.use(PullRefresh)
app.use(Empty)
app.use(Radio)
app.use(RadioGroup)
app.use(CountDown)
app.use(Search)
app.use(Image)
app.use(Collapse)
app.use(CollapseItem)
app.use(SwipeCell)


// 全局注册自定义组件
app.component('NavMenu', NavMenu)

app.use(pinia)
app.use(router)

// 注册全局混入，使handleGlobalBack方法、AssetPrefix变量和分页配置在所有组件中可用
app.mixin({
  methods: {
    handleGlobalBack
  },
  computed: {
    AssetPrefix() {
      return API_CONFIG.MEDIA_URL
    },
    // 分页配置常量
    PAGE_NUM() {
      return PAGE_CONFIG.PAGE_NUM
    },
    PAGE_SIZE() {
      return PAGE_CONFIG.PAGE_SIZE
    },
    PAGE_ARRAY() {
      return PAGE_CONFIG.PAGE_ARRAY
    }
  }
})

app.mount('#app')
